<template>
  <div class="fts-dashboard">
    <div class="fts-client-header">
      <div class="client-header-center">
        <font-awesome-icon :icon="['fas', 'th-large']" fixed-width size="lg" class="client-header-icon" />
        <div class="client-header-title">My Dashboard</div>
      </div>
    </div>
    <!-- actions -->
    <div class="d-actions">
      <fts-btn outline text-transform-init @click="initDashboard" :disabled="loading">
        <font-awesome-icon :icon="['fas', 'sync-alt']" /> Refresh
      </fts-btn>
    </div>
    <!-- container -->
    <div class="d-container">
      <div class="d-wrapper" v-for="x in design" :key="x.id">
        <!-- widget (drggable item) -->
        <template v-for="w in x.widgets">
          <fts-dashboard-widget 
            :widget="w"
            :dashboardData="dashboardData"
            :loading="loading"
            :activity-everyone="activityEveryone"
            :key="w.id"
            @activity:everyone="showActivityEveryone"
            @activity:individual="showActivityIndividual"
            @widget:click="executeActivity" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import commons from '../commons/commons';
import { clientStore } from "../store/clientStore";

import FTSDashboardWidget from "../dashboard-widget/FTSDashboardWidget";
import FTSBtn from "../elements/FTSBtn";

export default {
  components: {
    "fts-dashboard-widget": FTSDashboardWidget,
    "fts-btn": FTSBtn,
  },
  data: () => ({
    dashboardData: {},
    loading: false,
    design: [
      {
        widgets: [
          { 
            name: 'Calendar events', 
            columns: [
              {name: 'Happening Now', fieldName: 'happeningNow'},
              {name: 'Coming Soon', description: 'for next 30 days', fieldName: 'upcoming'},
            ],
            template: 'calendarEvent',
            color: 'var(--fts-dashboard-calendar)',
          },
          { 
            name: 'My Tasks', 
            columns: [  
              {name: 'Dues', description: 'first 50', fieldName: 'dues'},
              {name: 'Assigned To Me', description: 'first 50', fieldName: 'myTasks'}
            ],
            template: 'locus',
            color: 'var(--fts-dashboard-task)',
          }
        ]
      },
      {
        widgets: [
          {
            name: 'Activity Stream',
            fieldName: 'myActivities',
            template: 'activityStream',
            viewMode: true,
          },
        ]
      },
      {
        widgets: [
          {
            name: 'Mentioned Me', 
            columns: [
              {fieldName: 'mentionedMe'}
            ],
            template: 'locus',
            color: 'var(--fts-dashboard-mention)',
          },
          {
            name: 'My Watch', 
            columns: [
              {fieldName: 'myWatchList'}
            ],
            template: 'locus',
            color: 'var(--fts-dashboard-watch)',
          },
          {
            name: 'My Initiated', 
            columns: [
              {fieldName: 'initiatedByMe'}
            ],
            template: 'locus',
            color: 'var(--fts-dashboard-initial)',
          },
        ]
      }
    ],
    activityEveryone: false,
  }),
  methods: {
    moment,
    showActivityIndividual() {
      this.activityEveryone = false;
      this.initDashboard();
    },
    async showActivityEveryone() {
      this.activityEveryone = true;
      this.initDashboard();
    },
    async initDashboard() {
      this.loading = true
      this.dashboardData = {}
      try {
        let res = await clientStore.dispatch('retrieveDashboard', {
          activityEveryone: this.activityEveryone,
        });

        this.dashboardData = {
          myTasks: res.data.myTasks || [],
          mentionedMe: res.data.mentionedMe || [],
          initiatedByMe: res.data.initiatedByMe || [],
          myWatchList: res.data.myWatchList || [],
          myActivities: res.data.myActivities || [],
          dues: res.data.dues || [],
          upcoming: res.data.upcoming || [],
          happeningNow: res.data.happeningNow || [],
        }
        // temp
        this.dashboardData.myTasks = _.orderBy(this.dashboardData.myTasks, x => x.audit.updatedDate, ['desc'])
      } catch(err) {
        if (err.response && err.response.data && err.response.data.message)
          console.error(err.response.data.message)
        else 
          console.error("unable load dashboard");
      }
      this.loading = false
    },
    executeActivity(data) {
      if (commons.elementStopPropagation()) return
      
      window.eventBus.$emit("quickViewData", {
        items: [{...data, documentId: data.document && data.document.documentId}],
      });
    }
  },
  computed: {
    workspaceId() {
      return clientStore.getters.workspaceId
    },
  },
  watch: {
    workspaceId() {
      this.initDashboard()
    }
  },
  async mounted()  {
    await this.initDashboard();

    const locusId = commons.decodeids(this.$route.query.id);
    if (locusId) {
      window.eventBus.$emit("quickViewData", {
        items: [{id: locusId}],
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

$d-min-width: 350px;

.fts-dashboard {
  height: 100%;
  min-width: $d-min-width;
  overflow: auto;
  // background-image: url("https://images.unsplash.com/photo-1525465506244-dbc4f9638b42?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1951&q=80");
  // background-image: url("https://images.unsplash.com/photo-1509641498745-13c26fd1ed89?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=668&q=80");
  // background-image: url("https://images.unsplash.com/photo-1544991185-13fe5d113fe3?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=668&q=80");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  .d-actions {
    padding: 0 1rem ;
    text-align: right;
  }
  .d-container {
    display: flex;
    flex-wrap: wrap;
    padding: 0 1rem;
    .d-wrapper {
      flex: 1 1 #{$d-min-width};
      min-width: 0;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
